export default __webpack_public_path__ + "static/media/logo.d98ae4f9.png";